(function () {

  /* ── Find the delivery day select inside the open drawer ── */
  function findSelect() {
    var drawer = document.querySelector('cart-drawer-component dialog[open]');
    if (drawer) return drawer.querySelector('.delivery-day-selector__select');
    return document.querySelector('.delivery-day-selector__select');
  }

  /* ── Show shake + hint ── */
  function showError(select) {
    select.scrollIntoView({ behavior: 'smooth', block: 'center' });

    var hint = select.parentNode.querySelector('.delivery-day-hint');
    if (!hint) {
      hint = document.createElement('p');
      hint.className = 'delivery-day-hint';
      hint.textContent = '⚠ Please select a delivery day to continue.';
      select.parentNode.insertBefore(hint, select.nextSibling);
    }
    hint.classList.add('visible');

    select.classList.remove('delivery-day--shake');
    void select.offsetWidth;
    select.classList.add('delivery-day--shake');
    select.style.borderColor = '#e53935';

    setTimeout(function () {
      select.classList.remove('delivery-day--shake');
      select.style.borderColor = '';
    }, 600);

    select.addEventListener('change', function () {
      if (select.value) {
        hint.classList.remove('visible');
        select.style.borderColor = '';
      }
    }, { once: true });
  }

  /* ── Strip disabled from any checkout button that has data-requires-delivery-day ──
     The Horizon theme JS keeps re-adding it; this observer removes it immediately.  */
  var btnObserver = new MutationObserver(function () {
    document.querySelectorAll('.cart__checkout-button[data-requires-delivery-day][disabled]')
      .forEach(function (btn) { btn.removeAttribute('disabled'); });
  });
  btnObserver.observe(document.body, {
    subtree: true,
    attributes: true,
    attributeFilter: ['disabled']
  });

  /* ── Intercept clicks at capture phase (fires even before button handlers) ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cart__checkout-button[name="checkout"]');
    if (!btn) return;

    var select = findSelect();
    if (!select || select.value) return; // day selected — let through normally

    e.preventDefault();
    e.stopImmediatePropagation();
    showError(select);
  }, true /* capture */);

})();